<template>
    <v-row align="center">
        <ModalNuevaEmpresa :dialog.sync="dialog" :initialize.sync="initTable" :handleModal="handleModal" v-if="dialog"/>
        <ModalEditarEmpresa :dialogEdit.sync="dialogEdit" :dataEditEmpresa.sync="dataEditEmpresa"
        :initialize.sync="initTable" :handleModal="handleEditModal" v-if="dialogEdit">
        </ModalEditarEmpresa>
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">
                <div class="px-4 pt-2 pb-2">
                    <PageHeader title="Empresas" icon="fas fa-building" help="Catálogo de empresas del grupo.">
                        <template v-slot:primary>
                            <v-btn small dark color="primary" @click="dialog = true">
                                <v-icon left>fas fa-plus-square</v-icon>Nueva empresa
                            </v-btn>
                        </template>
                    </PageHeader>
                    <div class="filter-bar form-compact">
                        <v-text-field v-model="search" prepend-inner-icon="fas fa-search"
                            label="Buscar empresa por razón social" filled outlined hide-details clearable
                            class="filter-bar__grow" @keydown.enter="searchCompany" @click:clear="searchCompany">
                        </v-text-field>
                    </div>
                    <FilterChips :total="totalElements">
                        <template v-slot:tools>
                            <v-btn icon small aria-label="Actualizar" title="Actualizar" @click="reload()">
                                <v-icon small>fas fa-sync</v-icon>
                            </v-btn>
                            <span class="columns-btn-fix"><Columns :headers.sync="headers"></Columns></span>
                        </template>
                    </FilterChips>
                </div>
                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="empresas" class="elevation-1"
                :loading="loading" :options.sync="options"
                :server-items-length="totalElements" :items-per-page="itemsPerPage"
                :page.sync="page" @page-count="totalPages = $event"
                hide-default-footer>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                    <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item disabled>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>{{ item.razonSocial }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="editarEmpresa(item)">
                                    <v-list-item-title>
                                        <v-icon small class="mr-2">fas fa-edit</v-icon> Editar empresa
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="eliminarEmpresa(item)">
                                    <v-list-item-title class="red--text">
                                        <v-icon small class="mr-2 red--text">fas fa-trash-alt</v-icon> Borrar empresa
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.activo`]="{ item }">
                        <v-chip :color="colorstatus(item.activo)" label x-small dark
                            v-text="item.activo ? 'Activo' : 'Inactivo'">
                        </v-chip>
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
import EmpresaDataService from '../../service/catalogo/empresa/empresaDataService'
import ModalNuevaEmpresa from '@/components/empresa/NuevaEmpresa.vue';
import ModalEditarEmpresa from './EditarEmpresa.vue';
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import PageHeader from '@/components/shared/PageHeader.vue';
import FilterChips from '@/components/shared/FilterChips.vue';
import { extractMessage } from '@/helpers/errorHelper';
export default {
    name: "ListaEmpresa",
    components: {
        ModalNuevaEmpresa, ModalEditarEmpresa, Columns, PaginationNumber, PageHeader, FilterChips
    },
    mixins: [pagedTableMixin],
    created() {
        this.fetchTableData();
    },
    data() {
        return {
            empresas: [],
            dialog: false,
            dialogEdit: false,
            dataEditEmpresa: [],
            headers: [
                { text: "Acciones", value: "actions", sortable: false, groupable: false, show: true },
                { text: "ID", align: " d-none", sortable: false, value: "id", visible: false, groupable: false, show: false },
                { text: "Empresa", value: "empresa", sortable: false, groupable: false, show: true },
                { text: "Razon Social", value: "razonSocial", sortable: false, groupable: false, show: true },
                { text: "Direccion (g)", value: "direccion", sortable: false, groupable: false, show: true },
                { text: "Dominio", value: "dominio", sortable: false, groupable: false, show: true },
                { text: "Clave", value: "clave", sortable: false, groupable: false, show: true },
                { text: "RFC", value: "rfc", sortable: false, groupable: false, show: true },
                { text: "Estatus (g)", value: "activo", sortable: false, groupable: false, show: true },
            ]
        }
    },
    methods: {
        searchCompany() {
            this.doSearch();
        },
        fetchTable(params) {
            return EmpresaDataService.getallEmpresa(params);
        },
        applyRows({ rows, total, totalPages }) {
            this.empresas = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTable() {
            this.reload();
        },
        editarEmpresa(item) {
            EmpresaDataService.show(item.id).then(response => {
                this.dataEditEmpresa = response.data;
                this.dialogEdit = true;
            }).catch(err => {
                this.$swal.fire({ icon: 'error', title: 'Error al obtener la empresa', text: extractMessage(err), showConfirmButton: false, timer: 3000 });
            });
        },
        eliminarEmpresa(item) {
            this.$swal({
                title: "Estas seguro?",
                text: "No se podra revertir la decision!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, eliminar!"
            }).then(result => {
                if (result.isConfirmed) {
                    EmpresaDataService.delete(item.id).then(rsp => {
                        if (rsp.status === 200) {
                            this.initTable();
                            this.$swal.fire({ icon: 'success', title: 'Empresa eliminada', text: rsp.data.message, showConfirmButton: false, timer: 1500 });
                        }
                        if (rsp.status === 400 || rsp.status === 404) {
                            this.$swal.fire({ icon: 'error', title: 'Error al eliminar la empresa', text: rsp.data.message, showConfirmButton: false, timer: 3000 });
                        }
                    }).catch(err => {
                        this.$swal.fire({ icon: 'error', title: 'Error!!', text: extractMessage(err), showConfirmButton: false, timer: 3000 });
                    });
                }
            });
        },
        colorstatus(status) { return status ? "success" : "error"; },
        handleModal() { this.dialog = !this.dialog; },
        handleEditModal() { this.dialogEdit = !this.dialogEdit; },

    },
    computed: {
        filteredHeaders() { return this.headers.filter(h => h.show); },
    }
}
</script>
<style scoped>
/* `Columns` trae un mt-5 fijo; aquí se alinea con los demás iconos de la tabla */
.columns-btn-fix ::v-deep .v-btn {
    margin: 0 !important;
    color: var(--app-text-muted) !important;
}
.columns-btn-fix ::v-deep .v-btn .v-icon {
    font-size: 16px;
    color: inherit;
}
/* celular: los iconos de la tabla llegan a 40px para poder tocarlos */
@media (max-width: 599px) {
    .columns-btn-fix ::v-deep .v-btn {
        width: 40px;
        height: 40px;
    }
}
</style>